import React from "react";
import { TextField } from "@finpay-development/shared-components";
import { MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid";
import { FormSectionProps } from "../types";
import { stateAbbrevs } from "../../../../../shared/misc/us-states";
import "../../../../tab-styling.scss"

export const AddressInfoSection: React.FC<FormSectionProps> = ({
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
}) => {
    return (
        <Grid container spacing={2} className="address-info">
            <Grid item xs={6}>
                <TextField
                    name="streetAddress1"
                    label="Street Address"
                    value={values.streetAddress1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter Street Address"
                    className={`${touched.streetAddress1 && Boolean(errors.streetAddress1) ? 'error-border' : ""}`}
                    helperText={touched.streetAddress1 && errors.streetAddress1 ? String(errors.streetAddress1) : undefined}
                    test-id="patient-tab-street-address-1"
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    name="streetAddress2"
                    label="Address 2"
                    value={values.streetAddress2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Optional"
                    className={`${touched.streetAddress2 && Boolean(errors.streetAddress2) ? 'error-border' : ""}`}
                    helperText={touched.streetAddress2 && errors.streetAddress2 ? String(errors.streetAddress2) : undefined}
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    name="city"
                    label="City"
                    value={values.city}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter City"
                    className={`${touched.city && Boolean(errors.city) ? 'error-border' : ""}`}
                    helperText={touched.city && errors.city ? String(errors.city) : undefined}
                    test-id="patient-tab-city"
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    select
                    className={`state-field ${touched.state && Boolean(errors.state) ? 'error-border' : ""}`}
                    name="state"
                    label="State"
                    value={values.state}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Select State"
                    helperText={touched.state && errors.state ? String(errors.state) : undefined}
                    test-id="patient-tab-state"
                >
                    {stateAbbrevs.map((state: string) => (
                        <MenuItem key={state} value={state}>
                            {state}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={2}>
                <TextField
                    name="zipCode"
                    label="Zip Code"
                    value={values.zipCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter Zip Code"
                    className={`${touched.zipCode && Boolean(errors.zipCode) ? 'error-border' : ""}`}
                    helperText={touched.zipCode && errors.zipCode ? String(errors.zipCode) : undefined}
                    maxLength={5}
                    test-id="patient-tab-zip-code"
                />
            </Grid>
          <Grid item xs={2}>
            <TextField
                name="zipCode4"
                label="Zip Code 4"
                value={values.zipCode4}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Enter Zip Code 4"
                className={`${touched.zipCode4 && Boolean(errors.zipCode4) ? 'error-border' : ""}`}
                helperText={touched.zipCode4 && errors.zipCode4 ? String(errors.zipCode4) : undefined}
                maxLength={4}
                test-id="patient-tab-zip-code-4"
            />
          </Grid>
        </Grid>
    );
}; 